"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var HealthMetrics = /*#__PURE__*/function () {
  function HealthMetrics(options) {
    (0, _classCallCheck2.default)(this, HealthMetrics);
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "isSendBeaconAvailable", Boolean(window.navigator && window.navigator.sendBeacon));
    this.options = options;
  }

  (0, _createClass2.default)(HealthMetrics, [{
    key: "addPrefixToName",
    value: function addPrefixToName(payload) {
      var appName = this.options.appName;
      var name = "".concat(appName, ".").concat(payload.name);
      return _objectSpread(_objectSpread({}, payload), {}, {
        name: name
      });
    }
  }, {
    key: "send",
    value: function send(method, payload) {
      var error = HealthMetrics.validatePayload(method, payload);

      if (typeof error === 'string') {
        this.options.onError(error);
        return;
      }

      if (!this.isSendBeaconAvailable) {
        return;
      }

      var url = "".concat(this.options.apiRoot, "/").concat(method);
      var data = JSON.stringify(this.addPrefixToName(payload));
      window.navigator.sendBeacon(url, data);
    }
  }, {
    key: "increment",
    value: function increment(payload) {
      this.send('increment', payload);
    }
  }, {
    key: "decrement",
    value: function decrement(payload) {
      this.send('decrement', payload);
    }
  }, {
    key: "timing",
    value: function timing(payload) {
      this.send('timing', payload);
    }
  }], [{
    key: "validatePayload",
    value: function validatePayload(method, payload) {
      switch (method) {
        case 'increment':
        case 'decrement':
          {
            if (!payload.name) {
              return 'Health metrics tracking problem: invalid arguments';
            }

            break;
          }

        case 'timing':
          {
            if (!payload.name || !payload.value) {
              return 'Health metrics tracking problem: invalid arguments';
            }

            break;
          }

        default:
          return 'Health metrics tracking problem: invalid metric method';
      }

      return null;
    }
  }]);
  return HealthMetrics;
}();

var _default = HealthMetrics;
exports.default = _default;
//# sourceMappingURL=index.js.map